export default __webpack_public_path__ + "static/media/not_found.cf971f0d.svg";